import { format } from "date-fns";

export function UpcomingEvents({ events, onSelectDate }) {
  const upcomingEvents = events
    .filter((e) => new Date(e.date) >= new Date())
    .sort((a, b) => new Date(a.date) - new Date(b.date))
    .slice(0, 6);

  if (upcomingEvents.length === 0) {
    return null;
  }

  return (
    <div className="card-base p-6">
      <h2 className="text-xl font-semibold text-white font-['Outfit'] mb-4">
        Upcoming Events
      </h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {upcomingEvents.map((event) => (
          <div
            key={event.id}
            className="p-4 rounded-xl bg-slate-800/30 hover:bg-slate-800/50 transition-colors cursor-pointer"
            onClick={() => onSelectDate(new Date(event.date))}
            data-testid={`upcoming-event-${event.id}`}
          >
            <div className="flex items-center gap-2 mb-2">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: event.color }}
              />
              <span className="text-sm text-slate-400">
                {format(new Date(event.date), "MMM d")}
              </span>
              {event.source === "google" && (
                <span className="text-xs px-1.5 py-0.5 rounded bg-blue-500/20 text-blue-400">
                  G
                </span>
              )}
            </div>
            <h3 className="text-white font-medium truncate">{event.title}</h3>
            {event.time && (
              <p className="text-xs text-slate-500 mt-1">{event.time}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
